import { userLanguage, ValidLanguages } from '$translations/index';
import { EditPositionDto } from '$types/serverTypes/editPositionDto';
import {
  ErrorMessageEn,
  ErrorMessageEs,
  SuccessMessageEn,
  SuccessMessageEs,
} from '../../../../constants/alerts';
import { errorHandler, successHandler } from '../../../utils';
import {
  CompanyBuilder,
  DuplicatePositionInternalOutput,
} from '../companies.types';

export const duplicatePositionInternal = (builder: CompanyBuilder) =>
  builder.mutation<
    DuplicatePositionInternalOutput,
    { position: EditPositionDto }
  >({
    query: ({ position }) => {
      const cleanedPosition: any = { ...position };

      cleanedPosition.positionSkills = [
        ...(position.RequiredSkills?.map(
          ({ Id, Title }: { Id: number; Title: string }) => ({
            positionsId: position.JobPosition?.Id,
            skillId: Id,
            IsRequired: true,
            skill: { Id, Title, Deprecated: false },
          })
        ) || []),
        ...(position.NiceToHaveSkills?.map(
          ({ Id, Title }: { Id: number; Title: string }) => ({
            positionsId: position.JobPosition?.Id,
            skillId: Id,
            IsRequired: false,
            skill: { Id, Title, Deprecated: false },
          })
        ) || []),
      ];

      cleanedPosition.CustomJobTitle = position.CustomJobTitle
        ? position.CustomJobTitle
        : null;

      // just for fallback
      // @ts-ignore
      cleanedPosition.Skills_position = [
        ...(position.RequiredSkills || []),
        ...(position.NiceToHaveSkills || []),
      ];

      // Delete unneccesary props
      delete cleanedPosition.RequiredSkills;
      delete cleanedPosition.NiceToHaveSkills;
      return {
        url: '/positions/duplicate',
        method: 'POST',
        body: cleanedPosition,
      };
    },
    transformResponse: (queryResponse: DuplicatePositionInternalOutput) => {
      successHandler(
        userLanguage === ValidLanguages.es
          ? SuccessMessageEs.POSITION_DUPLICATED
          : SuccessMessageEn.POSITION_DUPLICATED,
        true
      );
      return queryResponse;
    },
    transformErrorResponse: (error) => {
      errorHandler(
        '[duplicatePositionInternal]',
        userLanguage === ValidLanguages.es
          ? ErrorMessageEs.PositionDuplicateError
          : ErrorMessageEn.PositionDuplicateError,
        error,
        true
      );
    },
  });
